export default {
  observation: (state) => state.observation,
  satisfaction: (state) => state.satisfaction,
  loadingFeedback (state) {
    return state.loadingFeedback
  },
  logoProviderFeedback (state) {
    return state.logoProviderFeedback === '' ? '' : state.logoProviderFeedback
  },
  type: (state) => state.type
}



// WEBPACK FOOTER //
// ./src/store/hotsite/feedback/getters.js